import {Mark, mergeAttributes} from '@tiptap/core'

const Bdi = Mark.create({
    name: 'bidi',
    parseHTML(){
      return [{tag: 'bdi'}]
    },
    renderHTML({ HTMLAttributes }) {
      return ['bdi', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
    },
    addCommands() {
      return {
        toggleBdi: () => ({ commands }) => {
          return commands.toggleMark(this.name)
        },
      }
    },
})

export default Bdi